import React from 'react'

const ComingSoonAllVersion = () => {
  return (
    <div >
      <div>
        Sorry, This site is not available for Desktop and Ipad versions.
        <span className='text-$orange ml-1'>
          But It's coming soon
        </span>
      </div>
      <div className='text-center text-$orange'>Try again by the mobile version</div>
    </div>
  )
}

export default ComingSoonAllVersion